export const authoringExamExtensions = {
  getSortedAuthoringQuestionSets() {
    const func = () =>
      this.getAuthoringQuestionSets().sortBy((questionSet) =>
        questionSet.getIn(['relationshipMeta', 'authoring_exam', this.getId(), 'position'], 0)
      );

    return this.cache('getSortedAuthoringQuestionSets', func);
  }
};
